import React, { useMemo } from 'react';
import { AbilityProvider } from '../lib/casl/AbilityContext';
import { createAppAbility } from '../lib/casl/abilities';
import { useAuth } from '../hooks/useAuth';

interface AbilityProviderWrapperProps {
  children: React.ReactNode;
}

/**
 * Wrapper component that automatically provides CASL abilities based on the current user
 */
export const AbilityProviderWrapper: React.FC<AbilityProviderWrapperProps> = ({ children }) => {
  const { user } = useAuth();

  // Create abilities based on current user
  const ability = useMemo(() => createAppAbility(user), [user]);

  return (
    <AbilityProvider ability={ability}>
      {children}
    </AbilityProvider>
  );
}; 